import { groupBy, min, sortBy } from 'lodash-es';
import { DateTime } from 'luxon';
import * as React from 'react';
import {
    DocumentUserAssignmentsFragment,
    EventsDocumentInput,
    UserAssignmentsDocumentOptions
} from '../../generated/types';
import { filterStartEndDates } from '../../vo/positionSlotUserInfo';
import { UserAssignmentsPage } from './userAssignmentsPage';

interface IUserAssignmentsProps {
    assignmentsInfos: DocumentUserAssignmentsFragment;
    date?: DateTime;
    endDate?: DateTime;
    eventDocument: EventsDocumentInput;
    options: UserAssignmentsDocumentOptions;
}

export const UserAssignments = (props: IUserAssignmentsProps) => {
    const vr = props.assignmentsInfos.event.volunteerRegistration;
    const assignments = React.useMemo(
        () =>
            filterStartEndDates(vr.positionsSlotsUsersInfos, props.date, props.endDate).filter(
                (psui) => {
                    if (
                        psui.position.tags.find(
                            (t) =>
                                t.name.trim().toLowerCase() === 'mission privée' ||
                                t.name.trim().toLowerCase() === 'document-assignments-excluded'
                        )
                    ) {
                        return false;
                    } else {
                        return true;
                    }
                }
            ),
        [vr, props.date, props.endDate]
    );
    const assignmentsByPosition = React.useMemo(
        () =>
            sortBy(
                Object.entries(groupBy(assignments, (a) => a.position.id)),
                ([_positionName, psuis]) =>
                    min(psuis.map((psui) => psui.positionSlot.range.start!.toMillis()))
            ),
        [assignments]
    );

    return (
        <>
            {assignmentsByPosition.map(([_positionName, psuis], index) => (
                <UserAssignmentsPage
                    key={index}
                    customFields={props.assignmentsInfos.organization.customFields.nodes}
                    document={props.eventDocument}
                    eventId={props.assignmentsInfos.event.id}
                    options={props.options}
                    organizationId={props.assignmentsInfos.organization.id}
                    psuis={psuis}
                    userInfo={props.assignmentsInfos.organization.userInfo}
                    volunteerRegistration={vr}
                />
            ))}
        </>
    );
};
